/** A landscape/portrait page section, not a range of the document - see the vocabulary in largeDocument. */
export const SECTION_NODE_NAME = 'section';

export const SECTION_CLASS_NAME = 'document-section';

export const SECTION_HTML_SELECTOR = `section.${SECTION_CLASS_NAME}`;
